export const changeSharingModeDataSet = { cy: 'change-sharing-mode-button' };
